import "./styles/App.css"
import RequestBalanceContainer from "./container/RequestBalanceContainer/RequestBalanceContainer";

const App = () => {
  return (
    <div className="App">
      <RequestBalanceContainer />
    </div>
  );
};

export default App;
